import service from '@/api/action';
import {loading, handleError} from '@/state/generators/helpers';
import {alert, changes} from "../generators/helpers";

export const state = {
    service: service('actions'),
    leadLoading: false,
    lead: {},
}

export const getters = {

    leadLoading: function (state) {
        return !!state.leadLoading;
    },
    lead: function (state) {
        return JSON.parse(JSON.stringify(state.lead));
    }
}

export const mutations = {
    'SET_LEAD_LOADING': function (state, loading = true) {
        state.leadLoading = loading;
    },

    'SET_LEAD': function (state, item = {}) {
        state.lead = item;
    },
}

export const actions = {
    realized: function ({commit, state}, id) {
        loading(commit)

        return state.service.realized(id).then(response => {
            const model = Object.assign({}, response.data)

            commit('REPLACE_ITEM', model);
            commit('SET_ITEM', model);
            alert(commit, this.$t('request.save_is_successful'))
            commit('SET_ERRORS', {});
            loading(commit, false)

            return model;
        }).catch((e) => {
            handleError(e, commit)
        })
    },

    fetchLeadAction: function ({commit, state}, id) {
        commit('SET_LEAD_LOADING');

        return state.service.fetchLeadAction({project_id: id}).then(response => {
            const model = Object.assign({}, response.data);
            commit('SET_LEAD', model);
            commit('SET_LEAD_LOADING', false);
            return model;
        }).catch((e) => {
            handleError(e, commit);
        })
    },

    saveLeadAction: function ({commit, state}, payload) {
        commit('SET_LEAD_LOADING');

        const { id, data } = changes(payload, state.lead)

        const content = Object.assign({_method: 'PUT'}, data)

        return state.service.update(id, content).then(response => {
            const model = Object.assign({}, data, response.data)

            commit('SET_LEAD', model);
            alert(commit, this.$t('request.save_is_successful'))
            commit('SET_ERRORS', {});
            commit('SET_LEAD_LOADING', false);

            return model;
        }).catch((e) => {
            handleError(e, commit)
        })
    },

    clearLeadAction: function ({commit}) {
        commit('SET_LEAD', {});
    },
}
